import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'windowOnboarding';

export const windowOnboardingI18nManifest: SliceI18nManifest = {
  owner: 'modules/window-onboarding',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
